import { Component, input, OnInit, output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInput, MatSuffix } from '@angular/material/input';
import { ButtonComponent } from '../button/button.component';
import { SearchbarTestIds } from './searchbar.test-ids';

@Component({
  selector: 'app-searchbar',
  imports: [MatIcon, MatTooltip, FormsModule, MatInput, MatSuffix, ReactiveFormsModule, ButtonComponent],
  templateUrl: './searchbar.component.html',
  styleUrl: './searchbar.component.scss'
})
/**
 * Die 'SearchbarComponent'-Klasse stellt eine Suchleiste zur Verfügung.
 * BEGRÜNDUNG: Es gibt keine AFO die eine Searchbar explizit vorschreibt.
 */
export class SearchbarComponent implements OnInit {
  protected readonly testIds = SearchbarTestIds;
  searchTerm = '';
  placeholder = input<string>('');
  dataTestId = input<string>('');
  searchTermChange = output<string>();
  groupOfForm = input<FormGroup>();
  controlName = input<string>('');
  formDataTestId = input<string>('');
  collapsed = input<boolean>();
  localPlaceholder = signal('');

  ngOnInit(): void {
    this.localPlaceholder.set(this.placeholder());
  }
  onSearchInputChange(): void {
    this.searchTermChange.emit(this.searchTerm);
  }

  searchClicked = output<string>();

  reset(): void {
    this.searchTerm = '';
    this.searchTermChange.emit(this.searchTerm);
  }

  onSearchClick(): void {
    this.searchClicked.emit(this.searchTerm);
  }
}
